
<div class="whole">
<div class="left-half">
    <img src="assets/img/user.png" alt="Blogger" height="150">

    <h3 style="font-size: 18px; font-weight:600">Satita Vittayaareekul</h3>
    <p>Finance & Computer Science @RU20'</p>
    <p>Thai based in VA, US</p>

    <hr style="width: 52%;">

    <div class="tag-option">
        <a class="blog-about">About</a>
        <a class="blog-tag">Tag</a>
        <a class="blog-current">Current Progress</a>
    </div>

    <!--Social Icons-->
    
    <div class="social-icons">
        <a href="#"><i class="fab fa-facebook-square"></i></a>
        <a href="#"><i class="fab fa-twitter"></i></a>
        <a href="#"><i class="fab fa-instagram"></i></a>
        <a href="#"><i class="fab fa-linkedin"></i></a>
    </div>
   
</div>

<div class="right-half">
    <!--<div markdown [src]="'assets/blog/blog.md'"></div>-->
    <h1 *ngIf="$blogPostMetadata | async as blogPost">{{blogPost.title}}</h1>
    <p *ngIf="$blogPostMetadata | async as blogPost">Blog Post by {{blogPost.author}}, {{blogPost.date}} -- {{blogPost.category}}</p>

    <hr>
    <!-- This is where Scully will inject the static HTML -->
    <scully-content></scully-content>
    <hr>
    <p><a href="/blog">Back to list..</a></p>

<!--

    <article>
        <h2>How I built this website, and what I would recommand for new bees </h2>
        <h5>09/01/2020</h5>
        <h5 style="color:purple">Angular</h5>
        <p> I have planned to build a personal website since 09/2019, have tried to implement in so many ways. And finally deployed it in 09/2020！
        <br>
        To be honest, a website doesn't take that long. The current verison of this website only took me less than a month. 
        <br>
        The hard part is to find the right way before you start!
        </p>
        <a href="/websiteblog" >Click to see the full blog about this~</a>
    </article>
-->

</div>

</div>